var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm._f("displayOptionalValue")(_vm.userName)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }